import { Component, Input } from '@angular/core';
import { ActiveParty } from 'src/app/Model/Types/ActiveParty';

@Component({
  selector: 'app-active-party',
  templateUrl: './active-party.component.html',
  styleUrls: ['./active-party.component.css']
})
export class ActivePartyComponent {
  @Input({required: true}) party!: ActiveParty;
  @Input({required: true}) index!: number;

  isExpanded = false;

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }
}
